module.exports = "<div *ngIf=\"loaderService.isLoading | async\">\n  <img src=\"./assets/img/Spinner-1s-100px.gif\" alt=\"cargando\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/loading.component.html
// module id = ./src/app/components/loading/loading.component.html
// module chunks = main